// src/components/BaseLayout.js
import React from 'react';
import { useAuth } from '../context/AuthContext';
import { Link } from 'react-router-dom';
import '../styles/BaseLayout.css';

const BaseLayout = ({ children }) => {
  const { isAuthenticated, username } = useAuth();
  console.log('BaseLayout rendering with auth:', { isAuthenticated, username });

  return (
    <div className="base-layout">
      <nav className="navbar">
        <div className="nav-brand">
          <Link to="/">Loenhart Training Systems</Link>
        </div>
        {isAuthenticated ? (
          <div className="nav-links">
            <Link to="/home">Home</Link>
            <Link to="/exercises">Exercises</Link>
            <Link to="/create-program">Programs</Link>
          </div>
        ) : (
          <div className="nav-links">
            <Link to="/login">Login</Link>
          </div>
        )}
      </nav>
      <main className="main-content">
        {children}
      </main>
    </div>
  );
};

export default BaseLayout;
